import React from 'react';

import { finishInsertingCeilingPlane } from '../../../../../store/actions/layout/ceilingPlaneActions';
import { updateInsertingCeilingPlane } from '../../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { PlaneInsertionSubPanel } from './PlaneInsertionSubPanel';

export function CeilingPlaneInsertionSubPanel() {
  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  const dispatch = useAppDispatch();

  if (insertingObjectInfo?.type !== 'ceilingPlane') return null;

  return (
    <PlaneInsertionSubPanel
      type="ceiling"
      insertionPlane={insertingObjectInfo.data}
      onChange={(changes) => {
        dispatch(updateInsertingCeilingPlane(changes));
      }}
      onInsert={async () => {
        await dispatch(finishInsertingCeilingPlane());
      }}
      onInsertAndRepeat={async () => {
        await dispatch(finishInsertingCeilingPlane({ postInsertionAction: 'repeat' }));
      }}
    />
  );
}
